import { render } from "./Disclaimer.vue?vue&type=template&id=1ba7c9ec"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=1ba7c9ec&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__